// extracted by mini-css-extract-plugin
export var orienterLink = "g_z";
export var searchContainer = "g_t";
export var searchDisplayTitleBold = "g_x";
export var searchDisplayTitleRegular = "g_y";
export var searchPageSpacer = "g_w";
export var subtitleContainer = "g_v";